import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { MemeGeneratorState } from "../types";
import { handleFetchFonts } from "./fetchFonts";

export const extraReducers = (builder: ActionReducerMapBuilder<MemeGeneratorState>) => {
    handleFetchFonts(builder);
};
